import { RxCoverageApplicationState } from "../RxCoverageApplication";

export const getFacilityName = (state: RxCoverageApplicationState) =>
  state.referral.facilityName;

export const getReferralQueryString = ({
  referral: {
    facilityCode,
    venueReferral: { data: venue },
  },
}: RxCoverageApplicationState) => {
  if (facilityCode) {
    return `?${new URLSearchParams({
      f: facilityCode.toUpperCase(),
    }).toString()}`;
  }

  if (venue) {
    return `?${new URLSearchParams({
      v: `${venue.facility.code}-${venue.venue.venueCode}`,
    }).toString()}`;
  }

  return "";
};
